import { ActionBoardStoreProvider } from '@/actionBoards/actionBoard.store';
import { AdministrationStoreProvider } from '@/administration/administration.store';
import { DatasourcesStoreProvider } from '@/administration/datasourceAdministration/datasources/datasources.store';
import { AgentBuilderStoreProvider } from '@/agentBuilder/agentBuilder.store';
import { AgentBuilderRunStoreProvider } from '@/agentBuilder/run/agentBuilderRun.store';
import { AnnotationStoreProvider } from '@/annotation/annotation.store';
import { DashboardStoreProvider } from '@/dashboard/dashboard.store';
import { ExploreFolderModalStoreProvider } from '@/explorer/exploreFolderModal.store';
import { ExploreWorkbookModalStoreProvider } from '@/explorer/exploreWorkbookModal.store';
import { AddOnToolStoreProvider } from '@/homescreen/addOnTool.store';
import { ImpactReportStoreProvider } from '@/impactReports/impactReports.store';
import { LicenseManagementStoreProvider } from '@/licenseManagement/licenseManagement.store';
import { LayoutStoreProvider } from '@/main/layout.store';
import { WorkbenchLayoutStoreProvider } from '@/main/workbenchLayout.store';
import { PdfExportStoreProvider } from '@/reportEditor/pdfExport.store';
import { SearchStoreProvider } from '@/search/search.store';
import { StoredTableStoreProvider } from '@/storedTableEditor/storedTable.store';
import { SystemWarningStoreProvider } from '@/systemWarning/systemWarning.store';
import { ScorecardStoreProvider } from '@/tableBuilder/scorecard.store';
import { ScalingTemplateStoreProvider } from '@/tableDefinitionEditor/scalingTemplate.store';
import { TableDefinitionEditorStoreProvider } from '@/tableDefinitionEditor/tableDefinitionEditor.store';
import { ClusteringV2StoreProvider } from '@/tools/clusteringV2/clustering.store';
import { DigitalFilterStoreProvider } from '@/tools/digitalFilter/digitalFilter.store';
import { DisplayToolStoreProvider } from '@/tools/display/displayTool.store';
import { FftStoreProvider } from '@/tools/frequencyAnalysis/fft.store';
import { IsolationForestV2StoreProvider } from '@/tools/isolationForestV2/isolationForest.store';
import { TemplateLibraryStoreProvider } from '@/tools/models/templateLibrary.store';
import { ToolTemplateStoreProvider } from '@/tools/models/toolTemplate.store';
import { OnnxStoreProvider } from '@/tools/onnx/onnx.store';
import { PartialLeastSquaresV2StoreProvider } from '@/tools/partialLeastSquaresV2/partialLeastSquares.store';
import { PredictionPanelStoreProvider } from '@/tools/prediction/predictionPanel.store';
import { PrincipalComponentAnalysisV2StoreProvider } from '@/tools/principalComponentAnalysisV2/principalComponentAnalysis.store';
import { SelfOrganizingMapsV2StoreProvider } from '@/tools/selfOrganizingMapsV2/selfOrganizingMaps.store';
import { SignalForecastStoreProvider } from '@/tools/signalForecast/signalForecast.store';
import { StatisticsSummaryStoreProvider } from '@/tools/statisticsSummary/statisticsSummary.store';
import { ThresholdMetricStoreProvider } from '@/tools/thresholdMetric/thresholdMetric.store';
import { ViewODataExportsStoreProvider } from '@/tools/viewODataExports/viewODataExports.store';
import { ViewStatisticSummariesStoreProvider } from '@/tools/viewStatisticSummaries/viewStatisticSummaries.store';
import { TimebarStoreProvider } from '@/trend/trendViewer/timebar.store';
import { CursorStoreProvider } from '@/trendData/cursor.store';
import { ItemRuntimeStoreProvider } from '@/trendData/itemRuntime.store';
import { TrendScalingColumnStoreProvider } from '@/trendData/trendScalingColumn.store';
import { VantageTrendStoreProvider } from '@/vantage/vantageTrend.store';
import { VantageWorkbookStoreProvider } from '@/vantage/vantageWorkbook.store';
import { WorkstepsStoreProvider } from '@/worksteps/worksteps.store';
import { createTestStoreProvider } from '@seeqdev/utils';

const storeProviders = {
  ActionBoard: ActionBoardStoreProvider,
  Administration: AdministrationStoreProvider,
  AgentBuilder: AgentBuilderStoreProvider,
  AgentBuilderRun: AgentBuilderRunStoreProvider,
  Annotation: AnnotationStoreProvider,
  ClusteringV2: ClusteringV2StoreProvider,
  Dashboard: DashboardStoreProvider,
  ExploreFolderModal: ExploreFolderModalStoreProvider,
  ExploreWorkbookModal: ExploreWorkbookModalStoreProvider,
  SystemWarning: SystemWarningStoreProvider,
  Datasources: DatasourcesStoreProvider,
  DigitalFilter: DigitalFilterStoreProvider,
  DisplayTool: DisplayToolStoreProvider,
  Fft: FftStoreProvider,
  IsolationForestV2: IsolationForestV2StoreProvider,
  Onnx: OnnxStoreProvider,
  PartialLeastSquaresV2: PartialLeastSquaresV2StoreProvider,
  Prediction: PredictionPanelStoreProvider,
  PrincipalComponentAnalysisV2: PrincipalComponentAnalysisV2StoreProvider,
  SelfOrganizingMapsV2: SelfOrganizingMapsV2StoreProvider,
  StatisticsSummary: StatisticsSummaryStoreProvider,
  ViewODataExports: ViewODataExportsStoreProvider,
  AddOnTool: AddOnToolStoreProvider,
  TableDefinitionEditor: TableDefinitionEditorStoreProvider,
  Timebar: TimebarStoreProvider,
  VantageTrend: VantageTrendStoreProvider,
  VantageWorkbook: VantageWorkbookStoreProvider,
  ImpactReport: ImpactReportStoreProvider,
  Layout: LayoutStoreProvider,
  ScalingTemplate: ScalingTemplateStoreProvider,
  ToolTemplate: ToolTemplateStoreProvider,
  WorkbenchLayout: WorkbenchLayoutStoreProvider,
  Worksteps: WorkstepsStoreProvider,
  LicenseManagement: LicenseManagementStoreProvider,
  PdfExport: PdfExportStoreProvider,
  Scorecard: ScorecardStoreProvider,
  Search: SearchStoreProvider,
  SignalForecast: SignalForecastStoreProvider,
  StoredTable: StoredTableStoreProvider,
  Cursor: CursorStoreProvider,
  TemplateLibrary: TemplateLibraryStoreProvider,
  ThresholdMetric: ThresholdMetricStoreProvider,
  ViewStatisticSummaries: ViewStatisticSummariesStoreProvider,
  TrendScalingColumn: TrendScalingColumnStoreProvider,
  ItemRuntime: ItemRuntimeStoreProvider,
} as const;

export const TestStoreProvider = createTestStoreProvider(storeProviders);
